import React from 'react';

export interface HeroProps {
  eyebrow?: string;
  title: string;
  tagline?: string;
  slim?: boolean;
}

export const Hero: React.FC<HeroProps> = ({ eyebrow, title, tagline, slim }) => (
  <div className={`hero${slim ? ' hero--slim' : ''}`}>
    <div className="hero-overlay">
      {eyebrow && (
        <p className="eyebrow" style={{ color: '#7fd3ea', marginBottom: 8 }}>
          {eyebrow}
        </p>
      )}
      <h1>{title}</h1>
      {!slim && tagline && (
        <p className="hero-tagline">{tagline}</p>
      )}
    </div>
  </div>
);
